import styled from 'styled-components'
import { theme } from '@/client/components'
const { space, breakpoint } = theme

export const Content = styled.div`
  padding-bottom: ${space.xl};

  @media (min-width: ${breakpoint.lg}) {
    padding: ${space.lg} 0 ${space.xl};
  }
`
export const TextContainer = styled.div`
  padding-top: ${space.lg};
  .strong-text,
  a {
    font-weight: 600;
  }
  a:hover {
    text-decoration: none;
  }
  @media (min-width: ${breakpoint.xl}) {
    padding-top: ${space.xl7};
  }
`
